import { Assumption } from '@portal/pkg-api/gen/navigator'
import { ControllerRenderProps } from 'react-hook-form'
import { ComponentType } from 'react'
import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { FilterCriteriaValueMultiSelect } from './FilterCriteriaValueMultiSelect'
import { FilterCriteriaValueText } from './FilterCriteriaValueText'
import { TextField } from '@mui/material'
import { FilterCriteriaValueBetween } from './FilterCriteriaValueBetween'
import { FilterCriteriaValueSelect } from './FilterCriteriaValueSelect'
import { NO_VALUE_OPERATORS } from '@portal/pkg-filter-criteria/model'
import { FilterCriteriaValueDate } from './FilterCriteriaValueDate'
import { FilterCriteriaValueYesNo } from './FilterCriteriaValueYesNo'
import { FilterCriteriaValueUserList } from './FilterCriteriaValueUserList'
import { FilterCriteriaValueMultiUser } from './FilterCriteriaValueMultiUser'
import { FilterCriteriaValueNumeric } from './FilterCriteriaValueNumeric'
import { FilterCriteriaValuePercentage } from './FilterCriteriaValuePercentage'
import { FilterCriteriaValueEntityRef } from './FilterCriteriaValueEntityRef'
import { FieldFilterRestrictionOperator } from '@portal/pkg-api/gen/admin'

export interface FilterCriteriaValueProps {
  field: ControllerRenderProps & { error: boolean }
  assumption: Assumption | null
  operator: FieldFilterRestrictionOperator | null
}

const registry: Record<string, ComponentType<FilterCriteriaValueFieldProps>> = {
  date: FilterCriteriaValueDate,
  select: FilterCriteriaValueSelect,
  multiselect: FilterCriteriaValueMultiSelect,
  yesno: FilterCriteriaValueYesNo,
  userlist: FilterCriteriaValueUserList,
  orguserlist: FilterCriteriaValueUserList,
  multiuser: FilterCriteriaValueMultiUser,
  currency: FilterCriteriaValueNumeric,
  numeric: FilterCriteriaValueNumeric,
  percentage: FilterCriteriaValuePercentage,
  entityref: FilterCriteriaValueEntityRef,
  default: FilterCriteriaValueText,
}

export function FilterCriteriaValue({ field, assumption, operator }: FilterCriteriaValueProps) {
  if (!assumption || !operator) {
    return <TextField variant="outlined" fullWidth disabled />
  }

  if (NO_VALUE_OPERATORS.includes(operator)) {
    return null
  }

  const Field = registry[assumption.type] ?? registry.default

  if (FieldFilterRestrictionOperator.BETWEEN === operator) {
    return (
      <FilterCriteriaValueBetween
        assumption={assumption}
        operator={operator}
        fieldProps={field}
        FieldComponent={Field}
      />
    )
  }

  return <Field assumption={assumption} operator={operator} fieldProps={field} />
}
